import styles from '@/app/_components/EventDetails/EventDetails.module.css'
import TXT from '@/messages'
import { ReactNode } from 'react'
import { isTruthy } from '@/utils/transformers.utils'
import { getEventMeta } from '@/utils/events.utils'
import { useEvent } from '@/app/_providers/EventProvider/EventProvider'

const SeatedNotice = (): ReactNode => {
  const primaryEventData = useEvent<Transformed.EventWithTimeslotsAndMeta>()
  const meta = getEventMeta(primaryEventData.meta)
  const isSeated = isTruthy(meta.seated)

  if (!isSeated) {
    return null
  }
  return (
    <>
      <div className={styles.IconContainer} data-testid="seated-icon">
        <img
          src="/static/events/svg/seated.svg"
          alt={TXT.eventsA11y.seatedEventIcon}
        />
      </div>
      <div data-testid="seated-description">
        {TXT.events.eventSeated}
      </div>
    </>
  )
}

export default SeatedNotice
